import type { RouteRecordRaw } from 'vue-router';

export const dentalAppointmentsRoutes: RouteRecordRaw[] = [
  {
    path: 'dental-appointments',
    name: 'dental-appointments',
    component: () => import('./pages/DentalAppointmentsCalendarPage.vue'),
    meta: { title: 'Appointments', requiresAuth: true, permission: 'view_dental_appointments' },
  },
  {
    path: 'dental-appointments/list',
    name: 'dental-appointments.list',
    component: () => import('./pages/DentalAppointmentsListPage.vue'),
    meta: { title: 'Appointments', requiresAuth: true, permission: 'view_dental_appointments' },
  },
  {
    path: 'dental-appointments/new',
    name: 'dental-appointments.create',
    component: () => import('./pages/DentalAppointmentFormPage.vue'),
    meta: {
      title: 'New appointment',
      requiresAuth: true,
      permission: 'create_dental_appointments',
    },
  },
  {
    path: 'dental-appointments/:id',
    name: 'dental-appointments.show',
    component: () => import('./pages/DentalAppointmentFormPage.vue'),
    meta: { title: 'Appointment', requiresAuth: true, permission: 'view_dental_appointments' },
  },
];
